// extracted by mini-css-extract-plugin
export var container = "shop-step-order-summary-module--container--8f7b0";
export var green = "shop-step-order-summary-module--green--8cfa0";
export var large = "shop-step-order-summary-module--large--bd58b";
export var name = "shop-step-order-summary-module--name--0fc19";
export var priceRow = "shop-step-order-summary-module--price-row--b7aa7";
export var strike = "shop-step-order-summary-module--strike--008c5";
export var value = "shop-step-order-summary-module--value--59e9b";